import type { HTMLAttributes } from 'react'
import { isRTLLanguage } from '@mote/helpers'
import type { SystemProps } from '@xstyled/styled-components'

export type DirectionForLanguage = {
  direction: HTMLAttributes<HTMLElement>['dir']
  alignment: SystemProps['textAlign']
}

export function getDirectionForLanguage(
  language: string
): DirectionForLanguage {
  const [direction, alignment] = isRTLLanguage(language)
    ? (['rtl', 'right'] as const)
    : (['ltr', 'left'] as const)
  return { direction, alignment }
}
